import React from 'react'

import { formatDateOnly } from './AgenticInsights.runReset'

// The right end of an insight card's top row: the day the insight was generated.
export const InsightCardMeta = ({ insight }) => (
  <span className="insight-card-meta">Generated {formatDateOnly(insight.createdAt)}</span>
)
